import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Grid, Table, TableBody, TableCell,
  Dialog, DialogActions, DialogContent, DialogTitle, 
  TableRow, TableHead, IconButton, Typography, } from '@mui/material'
import { fetchDispath } from '../../../functions/fetch'
import * as actions2 from '../../../reducers/formTable';
import {  changeAccessUser, loadUser } from '../../../api/users'
import * as actionsForm from '../../../reducers/form';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { rolesAllList } from '../../../api/list'
import { makeStyles } from '@mui/styles';
import AutoComplite from '../../../components/AutocompliteWithLoad'
import { addRowFormTable } from '../../../reducers/formTable'
const formUser = 'userProject'
export default function UsersById({ history, match }) {
  const idUser = match.params.idUser
  const dispatch = useDispatch()
  const [name, setName] = useState('')
  const [surname, setSurname] = useState('')
  const [patronymic, setPatronymic] = useState('')

  useEffect(() => {
    dispatch(actions2.initFormTable({ name: formUser }))
    return () => {
      dispatch(actions2.clearFormTable(formUser))
    }
  }, [dispatch])
  useEffect(() => {
    const fetchUser = {
      param: {
        id: idUser
      },
      progress: true,
    }
    dispatch(fetchDispath({ ...fetchUser, request: loadUser, }))
      .then(res => {
        setName(res.get.name)
        setSurname(res.get.surname)
        setPatronymic(res.get.patronymic || '')
        dispatch(actions2.loadFormTable({ get: res.get.roles, count: res.get.roles.length }, { name: formUser, id: 'id' }))

      })
  }, [dispatch, idUser])
  return <div className='App-paper'>
    <Typography variant='h6'>Профиль пользователя</Typography>
    <Grid container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <Grid item>{`Фамилия: ${surname}`}</Grid>
      <Grid item>{`Имя: ${name}`}</Grid>
      <Grid item>{`Отчество: ${patronymic}`}</Grid>
    </Grid>
    <Typography variant='h6'>Список ролей</Typography>
    <RolesTable idUser={idUser} />
    <Button color='primary' onClick={() => history.goBack()}>Назад </Button>
  </div>
}

function RolesTable({ idUser }) {
  const [addProject, setAddProject] = useState(false)
  const formTable = useSelector(state => state.formTable[formUser] || state.formTable.default)
  const handleOpenRoleDialog = () => setAddProject(!addProject)
  const { allIds, byId } = formTable
  const dispatch = useDispatch()
  const handleDeleteRole = (id, idRole) => {
    dispatch(actionsForm.formSubmitAPI({
      props: {
        roleId: idRole,
        add: false
      },
      url: changeAccessUser.path({ id: idUser }),
      method: changeAccessUser.type,
      success: actions2.deleteFormTable({ id: id }, { name: formUser })
    }, { name: formUser }))
  }
  return (
    <div>
      <AddRole
        open={addProject}
        handleOpen={handleOpenRoleDialog}
        idUser={idUser}
      />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: 10 }} padding={'none'}>
              <IconButton onClick={handleOpenRoleDialog} size="small"><AddIcon /></IconButton>
            </TableCell>
            <TableCell>ID</TableCell>
            <TableCell>Роль</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allIds.map(id => {
            const obj = byId[id];
            return (
              <TableRow key={id}>
                <TableCell style={{ width: 10 }} padding={'none'}>
                  <IconButton
                    aria-label="Delete"
                    onClick={(e) => { e.stopPropagation(); handleDeleteRole(id, obj.id); }}
                    size="small"><DeleteIcon /></IconButton>
                </TableCell>
                <TableCell>{obj.id}</TableCell>
                <TableCell>{obj.name}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 100,
  },
  main: {
    margin: theme.spacing(1)
  },
  paperOpen: {
    minHeight: 500,
  },
  paperClose: {
  },
  autocomplite: {
    minWidth: 300,
  },
}));

function AddRole({ open, handleOpen, idUser }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openMenu, setOpenMenu] = useState(false)
  const autocomplite = useSelector(state => state.autocomplite.roles || state.autocomplite.default)
  const handleClose = (add) => {
    if (add === true && autocomplite.value.value) {
      dispatch(actionsForm.formSubmitAPI({
        props: {
          roleId: autocomplite.value.value,
          add: true
        },
        url: changeAccessUser.path({ id: idUser }),
        method: changeAccessUser.type,
        success: addRowFormTable({
          id: autocomplite.value.value,
          name: autocomplite.value.label,
        }, { name: 'userProject' })
      }, { name: formUser }))
      handleOpen(true)
    }
    else {
      handleOpen(false)
    }
  };
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleOpen}
      maxWidth='sm' fullWidth
      PaperProps={{ className: openMenu ? classes.paperOpen : classes.paperClose }}
    >
      <DialogTitle>Добавить роль</DialogTitle>
      <DialogContent className={classes.autocomplite}>
        <AutoComplite
          classes={classes}
          field='roles'
          name='Роли'
          path={rolesAllList.path}
          meta={{
            field: 'roles',
            value: 'id',
            labelFunc: (obj) => obj.name
          }}
          selectProps={{
            onMenuOpen: () => setOpenMenu(true),
            onMenuClose: () => setOpenMenu(false)
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="primary">
          Отмена
        </Button>
        <Button onClick={() => handleClose(true)} color="primary" autoFocus>
          Добавить
        </Button>
      </DialogActions>
    </Dialog>)
}